import { Component, ChangeDetectorRef } from '@angular/core';
import { IonicPage, NavController, NavParams, Platform } from 'ionic-angular';
import { AlertController, LoadingController } from 'ionic-angular';
import { Camera, CameraOptions } from '@ionic-native/camera';
import { ImageResizer, ImageResizerOptions } from '@ionic-native/image-resizer';
import { SurveyProvider } from '../../providers/survey/survey';
import { ExtraProvider } from '../../providers/extra/extra';
import { ToastProvider } from '../../providers/toast/toast';
import { Ng2ImgToolsService } from 'ng2-img-tools';
import { Storage } from '@ionic/storage';
import { UtilService } from '../../services/util';
import { TranslateService } from '@ngx-translate/core';


declare let window: any;


@IonicPage()
@Component({
  selector: 'page-survey-detail',
  templateUrl: 'survey-detail.html',
})
export class SurveyDetailPage {
  name: any;
  description: any;
  questions = [];
  data = [];
  userSurvey = [];
  isSurveyGiven = false;
  showData = false;
  submitTitle = this.translate.instant('SUBMIT');
  isEdit = false;
  editSurvey = false;
  user_info: any;
  show_survey = true;
  loading = false;
  // imgUrl: any = null;
  changemore = true;
  changeless = false;
  answerurl: any;
  qIndex: any;
  attachment: any;
  user_role: any;
  user_tenant: any;
  imgUrl = [];



  // data=[];
  events: any;
  visit = "asap";
  commonAreas = [];
  uploaded: boolean = false;
  disableDesc = true;
  customAreas: any;
  compressing = false;
  isAndroid = true;

  options: CameraOptions = {
    quality: 90,
    destinationType: this.camera.DestinationType.FILE_URI,
    encodingType: this.camera.EncodingType.JPEG,
    mediaType: this.camera.MediaType.PICTURE,
    correctOrientation: true,
    saveToPhotoAlbum: false,
  }

  item: any;

  constructor(public navCtrl: NavController,
    private camera: Camera,
    private imageResizer: ImageResizer,
    public navParams: NavParams,
    private ref: ChangeDetectorRef,
    private extra: ExtraProvider,
    private surveyProvider: SurveyProvider,
    private toast: ToastProvider,
    private translate: TranslateService,
    private alertCtrl: AlertController,
    private platform: Platform,
    private storage: Storage,
    private util: UtilService,
    private loadingCtrl: LoadingController,
    private imageTools: Ng2ImgToolsService) {

    this.isAndroid = this.platform.is('android');
    // this.isAndroid = false;
    // console.log(this.isAndroid,"Check android")

    this.storage.get("loginDetails").then(val => {
      this.user_info = val;
      this.user_role = this.user_info['role']
      this.user_tenant = this.user_info['tenant']
      //   console.log( this.user_info ,"Hello Information")
      //   console.log( this.user_role ,"Hello Information")
      if (this.user_info.tenant == 1) {
        this.show_survey = this.navParams.get("show_tenant");
      }
    });
    this.attachment = this.navParams.get("attachment");
    //  console.log(this.attachment)
    this.name = this.navParams.get("name");
    this.description = this.navParams.get("description");
    surveyProvider.getSurvey(this.navParams.get("id")).then(val => {
      this.userSurvey = val;
      surveyProvider.getQuestions(this.navParams.get("id")).then(val => {

        this.questions = val['data'];
        this.generateOptions();

        if (this.userSurvey && this.userSurvey.length > 0) {
          this.isSurveyGiven = true;
          this.questions.forEach((que) => {
            que.res_id = que.id;
            if (this.userSurvey == []) {
            }
            this.userSurvey.forEach((ans) => {
              if (que.id == ans.question_id) {
                this.imgUrl.push(ans.answer);
                que.answer = ans.answer;
                que.comment = ans.comment;
                que.res_id = ans.id;
              }
            });
          });


        }
        this.showData = true;
      });
    });
  }



  openUrl(url: string) {
    this.util.openWithInAppBrowser(url);
  }


  qIndexFunction(i) {
    this.qIndex = i;
  }

  generateOptions() {
    this.questions.forEach((question) => {
      question.option = JSON.parse(question.option);
      let optionsObj = question['option']
      // console.log(optionsObj,"option")
      question.options = []

      for (let key in optionsObj) {
        question.options.push({
          name: optionsObj[key],
          value: key,
        });
        // console.log(question.options,"let boffer")
      }
    });

    this.questions.forEach((question) => {
      let optionsObj = question['data']
      let dataObj = optionsObj['comment']

      question.commentname = dataObj['label']
      // console.log(dataObj,"data")
      // for (let key in optionsObj) {
      //   question.datas.push({
      //     name: optionsObj[key],
      //     value: key,
      //   });
      //   console.log(question.datas,"let boffer")
      // }
    });
  }

  submit() {
    if (this.isSurveyCompleted()) {
      if (this.editSurvey) {
        this.submitEditedSurvey();
      } else {
        this.submitNewSurvey();
      }
    } else {
      return;
    }
  }

  submitEditedSurvey() {
    let data = [];
    this.questions.forEach(q => {
      if (!q.res_id) {
        this.toast.presentToast("Unable to edit");
      }
      data.push({
        answer: q.answer,
        comment: q.comment,
        type: q.type,
        id: q.res_id
      });

    });
    // console.log(data,"edit data")

    this.surveyProvider.editSurvey(data).then(val => {
      if (val.success) {
        this.toast.presentToast(val.message);
        this.navCtrl.pop();
      }
    });
  }

  submitNewSurvey() {
    let data = [];
    this.questions.forEach(q => {
      data.push(
        {
          answer: q.answer ? q.answer : '',
          comment: q.comment,
          question_id: q.id,
          type: q.type,
          survey_id: this.navParams.get("id"),

        }
      );
    });
    this.surveyProvider.submitSurvey(data).then(val => {
      if (val.success) {
        this.toast.presentToast(val.message);
        this.navCtrl.pop();
      }
    });
  }

  isSurveyCompleted(): boolean {
    let count = 0;
    // console.log(this.questions,"submit")
    this.questions.forEach(q => {
      if (q.answer && q.answer != "") {
        // console.log(q.answer,"i am here")
        count++;
      }
    });
    let total = this.questions.length;
    // console.log(total)
    // console.log(count)
    if (count < total) {
      this.showPrompt(count, total);
      return false;
    } else {
      return true;
    }
  }

  showPrompt(given: number, total: number) {
    let actions = [{ text: 'Cancel', handler: data => { } }];
    if (given > 0) {
      actions.push({
        text: 'Continue',
        handler: data => {
          if (this.editSurvey) {
            this.submitEditedSurvey();
          } else {
            this.submitNewSurvey();
          }
        }
      });
    }

    const prompt = this.alertCtrl.create({
      title: 'Alert',
      message: `You have answered ${given} out of ${total} questions. Do you want to continue ?`,
      buttons: actions
    });
    prompt.present();
  }


  changeMore() {
    this.changemore = true;
    this.changeless = false;
  }
  changeLess() {
    this.changemore = false;
    this.changeless = true;
  }

  edit() {
    this.submitTitle = this.translate.instant('SUBMIT');
    this.isEdit = true;
    this.isSurveyGiven = false;
    this.editSurvey = true
  }


  // Image Uploder   

  takePicture() {
    this.camera.getPicture(this.options).then((imageUri) => {
      let imgUri = imageUri;

      let options = {
        uri: imgUri,
        folderName: "isociety",
        quality: 90,
        width: 500,
        height: 500,
        fileName: 'resize.jpg'
      } as ImageResizerOptions;

      this.imageResizer.resize(options).then((uri: string) => {
        // console.log("resized file");
        // console.log(uri);
        return this.extra.convertUriToBase64IOS(uri).then(val => {
          this.imgUrl.splice(this.qIndex, 0);
          this.imgUrl[this.qIndex] = val.base64File
          // this.imgUrl.push(val.base64File);
          this.questions[this.qIndex]['answer'] = val.base64File;
          this.uploaded = true;
        })
      }).catch(e => this.displayErrorAlert(e));

    }, (err) => {
      this.displayErrorAlert(err);
    });

  };


  displayErrorAlert(err) {
    // console.log(err);
    // let alert = this.alertCtrl.create({
    //     title: 'Error',
    //     subTitle: 'Error while trying to capture picture',
    //     buttons: ['OK']
    //   });
    // alert.present();
  }

  fileChoose() {
    if (this.platform.is('ios')) {
      this.extra.imgPicker().then(val => {
          var file = 'data:image/jpeg;base64,' + val[0]
          this.imgUrl.splice(this.qIndex, 0);
          this.imgUrl[this.qIndex] = file
          // this.imgUrl.push(file);
          this.questions[this.qIndex]['answer'] = file;
          this.uploaded = true;
          this.ref.detectChanges();
      });
    } else {
      this.extra.chooseFile().then(val => {
        val.fileEntry.getMetadata(metadata => {
          if (metadata.size < 2000000) {
            if (val.file && (val.file.slice(-3) == "jpg" || val.file.slice(-3) == "png" || val.file.slice(-4) == "jpeg")) {
              this.imgUrl.splice(this.qIndex, 0);
              this.imgUrl[this.qIndex] = val.base64File
              //  this.imgUrl.push(val.base64File);
              this.questions[this.qIndex]['answer'] = val.base64File;
              this.uploaded = true;
              this.ref.detectChanges();
            } else {
              this.toast.presentToast("file should be an image");
            }
          } else {
            this.toast.presentToast("file size is greater than 2mb");
          }
        });
      });
    }
  }


  closeImg() {
    this.uploaded = false;
    this.imgUrl = null;
    this.ref.detectChanges();
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad SurveyDetailPage');
  }


  changeListener($event): void {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    var file: File = inputValue.files[0];
    this.compressing = true;
    this.imageTools.resize([file], 500, 500).subscribe(val => {
      var reader = new FileReader();
      reader.readAsDataURL(val);
      reader.onloadend = () => {
        // my_array.splice(start_index, number_of_elements_to_remove, 2);
        this.imgUrl.splice(this.qIndex, 0);
        this.imgUrl[this.qIndex] = reader.result
        //  this.imgUrl.splice(this.qIndex,this.qIndex - 1, reader.result);
        // console.log(this.imgUrl,"isSurveyGivenFalse")

        this.questions[this.qIndex]['answer'] = reader.result;
        this.uploaded = true;
        //console.log(this.imgUrl)     
      }
      this.compressing = false;
    }, err => {
      this.compressing = false;
      this.toast.presentToast("Unable to compress");
      console.log(err);
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/survey-detail/survey-detail.ts